<template>
  <Modal name="CONFIRM_UNLINK_MODAL" :title="title" :width="600" actions>
    <template v-slot:body>
      <h-loading v-if="isLoading" />
      <div v-else>
        <p class="body-2">
          {{ $t('deleteModal.wantToUnlink') }}
          <strong>{{ translatedAppointmentType }}</strong>?
        </p>
      </div>
    </template>
    <template v-slot:actions>
      <div class="d-flex">
        <v-btn
          @click="close"
          :disabled="isSubmitting"
          class="grey--text mr-5"
          elevation="0"
          large
          text
        >
          {{ $t('forms.cancel') }}
        </v-btn>
        <v-btn
          @click="confirmUnlink"
          :loading="isSubmitting"
          :disabled="isSubmitting"
          color="error"
          elevation="0"
          large
        >
          {{ $t('host.label.asaas.unlink') }}
        </v-btn>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/app/Modal'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ConfirmUnlinkModal',
  components: {
    Modal,
  },

  props: {
    item: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      isSubmitting: false,
      title: this.$t('customer.label.unlinkCustomerType'),
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'loading/isLoading',
      activeModal: 'activeModal',
    }),

    isModalOpen() {
      return this.activeModal === 'CONFIRM_UNLINK_MODAL'
    },

    translatedAppointmentType() {
      if (!this.item) return this.$t('appointment.type.undefined')

      if (this.item.typeLabel) return this.item.typeLabel

      const code =
        this.item.appointment_type ??
        this.item.appointmentType ??
        this.item.type ??
        this.item.value ??
        null

      return code
        ? this.$t(`appointment.type.${code}`)
        : this.$t('appointment.type.undefined')
    },
  },

  watch: {
    isModalOpen(val) {
      if (!val) {
        this.$emit('close')
        this.$emit('refresh')
      }
    },
  },

  methods: {
    ...mapActions(['unlinkServiceType', 'closeModal']),

    close() {
      this.$store.dispatch('closeModal', 'CONFIRM_UNLINK_MODAL')
    },

    async confirmUnlink() {
      try {
        this.isSubmitting = true
        const id = this.item?.id ?? null
        await this.unlinkServiceType(id)

        this.$emit(
          'success',
          this.$t('confirmUnlinkModal.successMessage') || 'Desvinculado com sucesso'
        )

        this.close()
      } catch (error) {
        this.$emit(
          'error',
          error?.message || this.$t('confirmUnlinkModal.errorMessage') || 'Erro ao desvincular'
        )
      } finally {
        this.isSubmitting = false
      }
    },
  },
}
</script>
